import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './signup.module.css';
import { useTranslation } from 'react-i18next';
function SignupSuccess() {
    const { t } = useTranslation();
    const { state } = useLocation();
    const isCompanyAlreadyExists = Boolean(state?.companyAlreadyExists);
    const [emailRows, setEmailRows] = useState([
        { id: 1, email: '', role: 'Admin' },
        { id: 2, email: '', role: 'Admin' }
    ]);

    const addEmailRow = () => {
        if (emailRows.length < 5) {
            const newRow = {
                id: emailRows.length + 1,
                email: '',
                role: 'Admin'
            };
            setEmailRows([...emailRows, newRow]);
        }
    };

    const updateEmailRow = (id, field, value) => {
        setEmailRows(emailRows.map(row => 
            row.id === id ? { ...row, [field]: value } : row
        ));
    };
    return (
        <div className={styles.InscriptionInvitationcollaborateur}>
           {/* <div className={styles.invitationModal}>
                <h2 className={styles.modalTitle}>Invitez votre équipe à collaborer</h2>
                
                <div className={styles.linkSection}>
                    <div className={styles.sectionTitle}>Inviter avec un lien</div>
                    <div className={styles.linkRow}>
                        <input 
                            type="text" 
                            value="https://typix2665657/invitationcollabor..." 
                            readOnly 
                            className={styles.linkInput}
                        />
                        <button className={styles.copyButton}>
                           
                            Copier 
                            <img src="/Images/icons/iconcopy.png" alt="copy" className={styles.copyIcon} />
                        </button>
                    </div>
                </div>

                <div className={styles.emailSection}>
                    <div className={styles.sectionTitle}>Inviter par e-mail</div>
                    {emailRows.map((row) => (
                        <div key={row.id} className={styles.emailRow}>
                            <input 
                                type="email" 
                                placeholder="Ajouter une adresse email ici" 
                                className={styles.emailInput}
                                value={row.email}
                                onChange={(e) => updateEmailRow(row.id, 'email', e.target.value)}
                            />
                            <select 
                                className={styles.roleSelect}
                                value={row.role}
                                onChange={(e) => updateEmailRow(row.id, 'role', e.target.value)}
                            >
                                <option value="Admin">Admin</option>
                                <option value="Rédacteur">Rédacteur</option>
                                <option value="Chef de projet">Chef de projet</option>
                            </select>
                        </div>
                    ))}
                    <button 
                        className={styles.addButton} 
                        onClick={addEmailRow}
                        disabled={emailRows.length >= 5}
                    >
                        {emailRows.length >= 5 
                            ? "Maximum atteint" 
                            : "+ Ajouter un collaborateur"
                        }
                    </button>
                </div>

                

                <div className={styles.actionButtons}>
                    <button className={styles.inviteButton}>Invitez votre équipe</button>
                    <Link to="/login"><button className={styles.remindLater}>Me le rappeler plus tard</button></Link>
                </div>
            </div>*/}
            <div className={styles.Cardintrieure}>
                <div className={styles.cardEllipse}></div>
                <div className={styles.cardText}>Bénédicte</div>
                <div className={styles.Admin}>Admin</div>
                <div className={styles.iconContent}></div>
                <div className={styles.contentTeam}>Content team</div>
            </div>
            <div className={styles.CardPaul}>
                <div className={styles.cardEllipsePaul}></div>
                <div className={styles.cardTextPaul}>Paul</div>
                <div className={styles.AdminPaul}>Rédacteur</div>
                <div className={styles.iconContentPaul}></div>
                <div className={styles.contentTeamPaul}>Content team</div>
            </div>
            <div className={styles.CardMarie}>
                <div className={styles.cardEllipseMarie}></div>
                <div className={styles.cardTextMarie}>Marie</div>
                <div className={styles.AdminMarie}>Chef de projet</div>
                <div className={styles.iconContentMarie}></div>
                <div className={styles.contentTeamMarie}>Content team</div>
            </div>
            <div className={styles.Ellipse30}>
                <div className={styles.smallEllipse}>
                    <div className={styles.Ellipse32}>
                        <div className={styles.Ellipse33}>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.smallEllipseImage}></div>
            <div className={styles.successCard}>
                <img src="/Images/new1-logo.png" alt="Logo Typix" className={styles.logo} />

                <h1 className={styles.successTitle}>{t('Inscription réussie ! 🎉')}</h1>
                <p className={styles.successMessage}><button className={styles.remindLater}>{isCompanyAlreadyExists ? (<>
                    Bonne nouvelle 👍Votre entreprise utilise déjà Typix Neo.
                    <br />
                    <br />
                    Votre compte a bien été créé, mais nécessite une validation par un administrateur.
                    <br />
                    Vous serez notifié par email dès que votre accès sera activé.
                </>) : t("Votre compte a bien été créé. Veuillez cliquer sur le lien envoyé par e-mail afin de l’activer.")}</button>
                </p>
            </div>
        </div>
    );
}

export default SignupSuccess;
